import { Input, Select } from "antd";
import { Search } from "lucide-react";
import type { CustomerToolbarProps } from "../../types";

const { Option } = Select;

export function CustomersToolbar({
  searchValue,
  onSearchChange,
  status,
  onStatusChange,
}: CustomerToolbarProps) {
  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-4">
        <div className="flex items-center gap-2 flex-1">
          <Input
            placeholder="Search customers..."
            prefix={<Search size={16} />}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            allowClear
            className="w-full "
          />
        </div>

        <div className="flex items-center gap-3 ml-auto">
          <Select value={status} onChange={onStatusChange} className="w-36">
            <Option value="all">All</Option>
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
          </Select>
        </div>
      </div>
    </div>
  );
}

export default CustomersToolbar;
